//Imports
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from 'react-select';
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";
//Import Components
import Loading from "../../../shared/ui-loading/Loading";
//Imports contexts
import { AppContext } from "../../../contexts/AppContext";
import { AuthContext } from "../../../contexts/AuthContext";
import staticData from '../../../contexts/staticData.json';
//Imports icons
import downArrow from '../../../assets/icons/downArrow.svg';
import downArrowWhite from '../../../assets/icons/downArrowWhite.svg';
import addUser from '../../../assets/icons/addUser.svg';
import userLogo from '../../../assets/icons/user.svg';
//Imports CSS
import './addUserForm.css';


function EditUserForm({ onClose, show, userId }) {
    const { establishmentList, usersList } = useContext(AppContext);
    const { userData } = useContext(AuthContext);
    const [dimension, setDimension] = useState(null);
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [formError, setFormError] = useState(null);
    const [isAdminHolder, setIsAdminHolder] = useState(false);

    useEffect(() => {
        if (userId) {
            const userToEdit = usersList.find((user) => user.id === userId)
            if (userToEdit) {
                // Formateamos el número de teléfono inicial si existe
                let formattedPhone = '+56';
                if (userToEdit.phoneNumber) {
                    const initialNumber = userToEdit.phoneNumber.replace(/\D/g, '');
                    if (initialNumber.startsWith('56')) {
                        formattedPhone = `+56${initialNumber.substring(2)}`;
                    } else {
                        formattedPhone = `+56${initialNumber}`;
                    }
                }
    
                setUser({
                    ...userToEdit,
                    phoneNumber: formattedPhone
                });
                setDimension(userToEdit.dimension);
                setIsAdminHolder(userToEdit.permissions === 'admin-holder');
            }
            setLoading(false);
        }
    }, [userId, usersList]);

    const filteredEstablishment = establishmentList?.filter((establishment) => establishment.projectId === user?.tenantId);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phoneNumber') {
            let numbers = value.replace(/\D/g, '');
    
            if (numbers.startsWith('56')) {
                numbers = numbers.substring(2);
            }
    
            numbers = numbers.substring(0, 9);
            const formattedNumber = numbers ? `+56${numbers}` : '+56';
    
            setUser(prevState => ({
                ...prevState,
                [name]: formattedNumber
            }));
        } else {
            setUser(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const updateData = {
                displayName: user.displayName,
                phoneNumber: user.phoneNumber,
                state: user.state,
                permissions: user.dimension === 'Sostenedor' && isAdminHolder ? 'admin-holder' : null,
            };
            // Agregar campos específicos según la dimensión
            if (user.dimension === 'Sostenedor') {
                updateData.department = user.department;
            } else if (user.dimension === 'Establecimiento') {
                updateData.establishment = user.establishment;
            }

            //Actualización de usuario en Firestore
            await updateDoc(doc(db, 'users', userId), updateData);
            console.log('usuario actualizado con exito', userId);
            onClose(true);
        } catch (error) {
            console.error('Error al actualizar usuario:', error);
            setFormError(error.message);
        }
    };
    if (loading) {
        return <Loading />;
    }

    return (
        <form className={`container-form-add-project flex ${show ? 'show' : 'hidden'}`} onSubmit={handleSubmit} >
            <div className='container flex'>
                <article className='first-box flex'>
                    <span className='input-select dimension-select'>
                        <label htmlFor='dimension' className='label-hidden'>Dependencia</label>
                        <Select
                            name='dimension'
                            id='dimension'
                            options={staticData.dimension.map((dimension) => ({
                                value: dimension,
                                label: dimension
                            }))}
                            placeholder='Selecciona dimensión'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator }}
                            value={dimension ? { value: dimension, label: dimension } : null}
                            isDisabled={true}
                        />
                    </span>
                    <span className='input-box'>
                        <label htmlFor='displayName' className='label'>Nombre de Usuario</label>
                        <input
                            type='text'
                            id='displayName'
                            name='displayName'
                            className='input'
                            placeholder={user?.displayName || 'Ingrese nombre del nuevo usuario'}
                            value={user?.displayName || ''}
                            onChange={handleInputChange}
                        />
                    </span>
                    <span className='input-box'>
                        <label htmlFor='phoneNumber' className='label'>Contacto</label>
                        <input
                            type='tel'
                            id='phoneNumber'
                            name='phoneNumber'
                            className='input'
                            placeholder='Ej: +56XXXXXXXXX'
                            value={user?.phoneNumber || '+56'}
                            onChange={handleInputChange}
                            maxLength='12'
                        />
                    </span>
                </article>
                <article className='second-box flex'>
                    <div className='box-photo flex'>
                        <img src={userLogo} className='icon' alt='Icono de foto de usuario' />
                    </div>
                </article>
            </div>
            <aside className='box-variable flex'>
                <span className='input-select'>
                    <label htmlFor='state' className='label'>Estado</label>
                    <Select
                        name='state'
                        id='state'
                        options={staticData.states.map((state) => ({
                            value: state,
                            label: state
                        }))}
                        placeholder='Selecciona estado'
                        className='custom-select'
                        classNamePrefix='custom-select'
                        components={{ DropdownIndicator2 }}
                        value={user?.state ? { value: user.state, label: user.state } : null}
                        onChange={(selectedOption) => setUser((prevState) => ({
                            ...prevState,
                            state: selectedOption.value
                        }))}
                    />
                </span>
                {dimension === 'Sostenedor' ? (
                    <span className='input-select'>
                        <label htmlFor='state' className='label'>Departamento de Administración</label>
                        <Select
                            name='department'
                            id='department'
                            options={staticData.departments.map((department) => ({
                                value: department,
                                label: department
                            }))}
                            placeholder='Selecciona estado'
                            className='custom-select'
                            classNamePrefix='custom-select'
                            components={{ DropdownIndicator2 }}
                            value={user?.department ? { value: user.department, label: user.department } : null}
                            onChange={(selectedOption) => setUser((prevState) => ({
                                ...prevState,
                                department: selectedOption.value
                            }))}
                        />
                        {userData?.permissions === 'admin' && (
                            <span className='input-checkbox flex'>
                                <label htmlFor='permissions' className='input-check-label flex'><p>Permisos de Administrador</p></label>
                                <input
                                    type='checkbox'
                                    checked={isAdminHolder}
                                    onChange={(e) => setIsAdminHolder(e.target.checked)}
                                    className='input-check flex'
                                />
                            </span>
                        )}
                    </span>
                ) : (dimension === 'Establecimiento' &&
                    <>
                        <span className='input-select'>
                            <label htmlFor='state' className='label'>Establecimiento</label>
                            <Select
                                name='establishment'
                                id='establishment'
                                options={filteredEstablishment.map((establishment) => ({
                                    value: establishment.nameEstablishment,
                                    label: establishment.nameEstablishment
                                }))}
                                placeholder='Selecciona estado'
                                className='custom-select'
                                classNamePrefix='custom-select'
                                components={{ DropdownIndicator2 }}
                                value={user?.establishment ? { value: user.establishment, label: user.establishment } : null}
                                onChange={(selectedOption) => setUser((prevState) => ({
                                    ...prevState,
                                    establishment: selectedOption.value
                                }))}
                            />
                        </span>
                        <span className='input-box'>
                            <label htmlFor='displayName' className='label'>Cargo</label>
                            <input
                                type='text'
                                id='department'
                                name='department'
                                className='input'
                                placeholder='Ingrese cargo'
                                value={user?.department || ''}
                                onChange={handleInputChange}
                            />
                        </span>
                    </>
                )}

            </aside>
            {formError && <p className="error-message">{`Error al editar usuario: ${formError}`}</p>}
            <aside className='fourth-box flex'>
                <button className='box-button flex' type='submit'>
                    <img src={addUser} className='icon' alt='Icono boton agregar nuevo usuario' />
                    <p>Editar Usuario</p>
                </button>
                <p onClick={() => onClose(false)}>Cancelar</p>
            </aside>
        </form>
    )
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrowWhite} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

const DropdownIndicator2 = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default EditUserForm;